import React from 'react'
import PropTypes from 'prop-types'
import { Overlay, Container, Main, Title, Header, CloseButton } from './modal-style'

const Modal = ({ id, isOpened, className, title, customTitle, children, onClose, removeCloseButton }) => {
  return (
    isOpened && (
      <Overlay id={id} className="overlay">
        <Container className={className}>
          <Header>
            <Title>{title || customTitle}</Title>
            {!removeCloseButton && <CloseButton onClick={onClose}>X</CloseButton>}
          </Header>
          <Main>{children}</Main>
        </Container>
      </Overlay>
    )
  )
}

Modal.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  show: PropTypes.bool,
  title: PropTypes.string,
  customTitle: PropTypes.object,
  children: PropTypes.any,
  onClose: PropTypes.func,
  isOpened: PropTypes.bool.isRequired,
  removeCloseButton: PropTypes.bool,
}
Modal.displayName = Modal

export default Modal
